export default "__VITE_ASSET__C$Wi3WQ8__"